import React from 'react';
import './ProductDocuments.css';

// "Specifications and manuals" - the downloadable documents for a product.
//
// The list comes from the API's derived `documents` field, which only includes
// files that actually exist on disk, so there is nothing to check here: if the
// array is empty the section does not render at all. No email gate, no form -
// the links download directly.
function formatSize(bytes) {
  if (!Number.isFinite(bytes) || bytes <= 0) return null;
  if (bytes < 1024) return `${bytes} B`;
  const kb = bytes / 1024;
  if (kb < 1000) return `${Math.round(kb)} KB`;
  return `${(kb / 1024).toFixed(1)} MB`;
}

function PdfIcon() {
  return (
    <svg className="pdoc-icon" width="20" height="20" viewBox="0 0 24 24" fill="none"
         stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5Z" strokeLinejoin="round" />
      <path d="M14 3v5h5" strokeLinejoin="round" />
    </svg>
  );
}

// `title` and `subtitle` let a page that already has a "Specifications"
// heading name this block for what it is there - the downloads under the table.
export default function ProductDocuments({
  documents,
  title = 'Specifications and manuals',
  subtitle = 'Everything your installer needs, free to download, before you order.',
}) {
  const docs = Array.isArray(documents) ? documents.filter((d) => d && d.url) : [];
  if (docs.length === 0) return null;

  return (
    <section className="pdoc">
      <h3 className="pdoc-title">{title}</h3>
      {subtitle && <p className="pdoc-sub">{subtitle}</p>}

      <ul className="pdoc-list">
        {docs.map((d, i) => {
          const size = formatSize(d.size);
          return (
            <li className="pdoc-row" key={i}>
              <a className="pdoc-link" href={d.url} target="_blank" rel="noopener noreferrer" download>
                <PdfIcon />
                <span className="pdoc-text">
                  <span className="pdoc-label">{d.label}</span>
                  {size && <span className="pdoc-size">PDF, {size}</span>}
                </span>
                <svg className="pdoc-download" width="16" height="16" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
                  <path d="M12 3v11m0 0 4-4m-4 4-4-4M5 19h14" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </a>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
